const { default: findTaskByReferenceUseCase } = require("tasks/services/sign/findTaskByReferenceUseCase")
const { default: findInvoiceDetailByIdUseCase } = require("./findInvoiceDetailByIdUseCase")
const { default: updateInvoiceDetailUseCase } = require("./updateInvoiceDetailUseCase")

const addTaskToInvoiceDetail = async (invoice, ivaPercent, taskReference) => {
    const invoiceDetail = await findInvoiceDetailByIdUseCase(invoice.id)
    const { deviceName, description, budget } = await findTaskByReferenceUseCase(taskReference)
    
    const item = {
        reference: taskReference || "",
        description: `${deviceName} - ${description}` || "",
        unitPrice: budget || 0,
        units: 1
    }

    invoiceDetail.data.push(item)

    return updateInvoiceDetailUseCase(invoice, ivaPercent, invoiceDetail)
}

export default addTaskToInvoiceDetail